import data from "../../../../../src/ButtonGroup.docs.json";
import * as React from 'react';
export default {
  data,
  React
};